import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { useCart } from "../context/CartContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { t } = useI18n();
  const { clear } = useCart();
  const navigate = useNavigate();
  const [state, setState] = useState("checking"); // checking | success | failed | timeout
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let cancelled = false;
    const poll = async () => {
      if (attempts.current >= 8) { if (!cancelled) setState("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") {
          if (!cancelled) { setState("success"); clear(); }
          return;
        }
        if (data.status === "expired") { if (!cancelled) setState("failed"); return; }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  const Icon = state === "success" ? CheckCircle2 : state === "failed" ? XCircle : Loader2;
  const color = state === "success" ? "text-emerald-600" : state === "failed" ? "text-red-600" : "text-slate-500";

  return (
    <div className="max-w-md mx-auto py-24 px-6 text-center" data-testid="payment-success-page">
      <Icon className={`w-16 h-16 mx-auto ${color} ${state === "checking" ? "animate-spin" : ""}`} />
      <h1 className="font-display font-black text-3xl mt-6">
        {state === "checking" && t("payment.checking")}
        {state === "success" && t("payment.success")}
        {state === "failed" && t("payment.failed")}
        {state === "timeout" && t("payment.timeout")}
      </h1>
      {state === "success" && <p className="text-slate-600 mt-3">{t("payment.successMsg")}</p>}
      <button onClick={() => navigate("/orders")} className="btn-maroon mt-8 px-6 py-3 font-bold" data-testid="go-orders-btn">
        {t("payment.goOrders")}
      </button>
    </div>
  );
}
